// Events
import {
  PRODUCT_FORM_SCROLL_INTO_VIEW,
  PRODUCT_STICKY_FORM_HIDE,
  PRODUCT_STICKY_FORM_SHOW,
} from 'events';
import { component } from 'picoapp';

// Utils
import choozy from 'utils/choozy';
import scrollElementToPosition from 'utils/scrollElementToPosition';

export default component(async (node, ctx) => {
  const { productOptions, mainSubmitButton, jsData } = choozy(node);

  let data = null;
  try {
    if (jsData) {
      data = JSON.parse(jsData.innerHTML);
    }
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);
  }

  let selector = null;
  if (data) {
    selector = new Shopify.OptionSelectors(`product-${data.id}`, {
      product: data,
      enableHistoryState: false,
    });
  }

  document.addEventListener('product:form:update', (e) => {
    const props = e.detail;
    const { currentProductId } = props;
    const { forms } = ctx.getState();

    if (!data || data.id !== currentProductId) return;

    const { selectedVariant } = forms[currentProductId];

    if (!selectedVariant) return;

    const params = new URLSearchParams(window.location.search.slice(1));
    params.set('variant', selectedVariant.id);

    window.history.pushState({}, '', `?${params.toString()}`);

    // Not entirely sure why this is here. Probably used by the fit analytics app
    selector.selectors.forEach((item, index) => {
      item.element.value = selectedVariant.options[index];
      item.element.dispatchEvent(new Event('change'));
    });
  });

  ctx.on(PRODUCT_FORM_SCROLL_INTO_VIEW, async () => {
    if (!productOptions) return;
    try {
      await scrollElementToPosition(productOptions);
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
    }
  });

  const mainSubmitButtonHeight = mainSubmitButton.offsetHeight;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        ctx.emit(PRODUCT_STICKY_FORM_HIDE, { stickyFooterShown: false });
      } else {
        ctx.emit(PRODUCT_STICKY_FORM_SHOW, { stickyFooterShown: true });
      }
    },
    {
      root: null,
      rootMargin: `${mainSubmitButtonHeight / 2}px 0px ${mainSubmitButtonHeight}px 0px`,
      threshold: 1,
    },
  );

  if (mainSubmitButton) observer.observe(mainSubmitButton);
});
